module.exports = __webpack_public_path__ + "img/btn_shishishouqi@2x.6b66b28b.png";